import React from "react"
import Showcase from "../components/Showcase"
import { Window, View, QRCode, Input } from "react-ame-components"

export class QRCodeExample extends React.Component {
  state = {
    QRCodeValue: "",
  }

  inputOnChange = value => {
    this.setState({ QRCodeValue: value })
  }

  render() {
    return (
      <Showcase
        title="Componente ShowCase"
        description="Utilizado apenas para montar um QRCode na tela">
        <View>
          <Input
            placeholder="Digite aqui um valor"
            value={this.state.QRCodeValue}
            onChange={this.inputOnChange}
          />
        </View>
        <View margin="medium">
          <QRCode value={this.state.QRCodeValue} />
        </View>
      </Showcase>
    )
  }
}
